import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\src\\components\\ServicoCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\src\\components\\SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreFooter"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\src\\components\\StoreChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\src\\components\\VideoCarousel.tsx");
